<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Route, {router} from "../lib/Router/Router.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import A from "../lib/Router/A.svelte";
    import TransporterReports from "./TransporterReports.svelte";
    import TransporterDetailedReport from "./TransporterDetailedReport.svelte";
    import AccountReport from "./AccountReport.svelte";
    import AccountInvoicesReport from "./AccountInvoicesReport.svelte";
    import AccountTransporterReport from "./AccountTransporterReport.svelte";
    import DepartmentReport from "./DepartmentReport.svelte";
    import AbsorptionReport from "./AbsorptionReport.svelte";

    const breadcrumb = [
        {id: 'reports', name: 'Reports', link: `/app/reports`}
    ];

    const reports = [
        {name: 'Transporter', url: 'transporter'},
        {name: 'Transporter Detailed', url: 'transporter-detailed'},
        {name: 'Account', url: 'account'},
        {name: 'Account - Transporter', url: 'account-transporter'},
        {name: 'Account Invoices', url: 'account-invoices'},
        {name: 'Department', url: 'department'},
        {name: 'Absorption', url: 'absorption'},
    ];

    let accounts = null;
    let departments = null;
    let hotels = null;
    let transporters = null;
    let initialized = false;

    const initialize = () => {

        const onSuccess = result => {
            accounts = result.accounts;
            departments = result.departments;
            hotels = result.hotels;
            transporters = result.transporters;
            initialized = true;
        }

        const onFailure = err => {
        };

        R.handle(R.report.initialize, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    initialize();
</script>

<Route exact>
    <PageHeader title="Reports"/>
    <div class="row">
        <div class="col-xl-3">
            {#each reports as item}
                <A href="/app/reports/{ item.url }" class="btn btn-default btn-block mb-3">{ item.name}</A>
            {/each}
        </div>
    </div>
</Route>
{#if initialized}
    <Route match="*">
        <Breadcrumb {breadcrumb}/>
    </Route>
    <Route match="transporter" guard={ user.isGod }>
        <TransporterReports/>
    </Route>
    <Route match="transporter-detailed" guard={ user.isGod }>
        <TransporterDetailedReport {transporters}/>
    </Route>
    <Route match="account" guard={ user.isGod }>
        <AccountReport {accounts}/>
    </Route>
    <Route match="account-invoices" guard={ user.isGod }>
        <AccountInvoicesReport {accounts}/>
    </Route>
    <Route match="account-transporter" guard={ user.isGod }>
        <AccountTransporterReport {accounts} {transporters}/>
    </Route>
    <Route match="department" guard={ user.isGod }>
        <DepartmentReport {departments} {hotels}/>
    </Route>
    <Route match="absorption" guard={ user.isGod }>
        <AbsorptionReport {accounts} {transporters}/>
    </Route>
{/if}